module.exports = __webpack_public_path__ + "img/ic_32_register_google.99fb6281.svg";